import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';

import DeviceListGrid from './DeviceListGrid';
import Test from '../../atoms/Test/TimeLineChart';
import { TableUseStyle } from './DeviceListStyle';


const HomePage: React.FC = () => {
  //console.debug(['HomePage',]);
  const classes = TableUseStyle();
  return <DeviceListGrid tableContainerStyle={classes.tableContainer} />;
  //return <Test></Test>;
};

export default HomePage;
